module.exports = __webpack_public_path__ + "static/website-imac-4f8679e5ce742ba0ca2cdb23dae21528.png";